module.exports = __webpack_public_path__ + "static/media/Trending-down.f0b906dd.svg";